/**
 * Die Wortmarke KORA.
 *
 * Das O steht im Eichenherz-Rot, die übrigen Buchstaben in der Textfarbe der
 * Umgebung. Bewusst eine Komponente und keine CSS-Regel: Die Marke kommt an
 * mehreren Stellen und in sehr verschiedenen Größen vor – vom Anmeldebildschirm
 * bis zur schmalen Seitenleiste. Wer sie ändert, ändert sie überall.
 *
 * Größe, Laufweite und Schriftschnitt bleiben Sache der jeweiligen Umgebung;
 * hier wird ausschließlich die Farbe des O gesetzt.
 */

export function Wortmarke({ className }: { className?: string }) {
  return (
    <span className={`eh-marke ${className ?? ''}`}>
      K<span className="eh-marke-o">O</span>RA
    </span>
  );
}
